// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"UpgradeTiles__materialize-textarea___2p8OW","modal-2463794813":"UpgradeTiles__modal-2463794813___1VhmV","container":"UpgradeTiles__container___2c2ao","smallContainer":"UpgradeTiles__smallContainer___YXS9h","tilesContainer":"UpgradeTiles__tilesContainer___2_KjI","upgradeText":"UpgradeTiles__upgradeText___1YXUh","tiles":"UpgradeTiles__tiles___19Urf","tryButton":"UpgradeTiles__tryButton___3hT59"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UpgradeTiles/UpgradeTiles.scss
// module id = 1545
// module chunks = 0